export const state = {
  data:[]
};

// Declare state
export type State = typeof state;
